import { render, staticRenderFns } from "./FeaturePlan.vue?vue&type=template&id=45fd3a72&scoped=true"
import script from "./FeaturePlan.vue?vue&type=script&lang=js"
export * from "./FeaturePlan.vue?vue&type=script&lang=js"
import style0 from "./FeaturePlan.vue?vue&type=style&index=0&id=45fd3a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd3a72",
  null
  
)

export default component.exports